import React from "react";

import { useState } from "react";
import { useContext } from "react";
// import { v4 as uuidv4 } from 'uuid';

import NavPage from "../../../components/NavPage";

import FormEnvolvido from "./components/FormEnvolvido";
import EnvolvidoList from "./components/EnvolvidoList";
import CabecalhoBoletim from "../components/CabecalhoBoletim";
import { BoletimContext } from "../../../context/BoletimContext";
import { normalizarEnvolvido } from "./components/envolvidoUtils";

function Envolvidos (){
    const { boletim } = useContext(BoletimContext);

    // true  = formulario de envolvido exibe botao de atualizar o cadastro
    // false = formulario de envolvido exibe botao de adicionar o cadastro
    const [modoEdicao, setModoEdicao] = useState(() => {
        const draft = boletim.formDrafts?.envolvido;
        return Boolean(draft && (boletim.envolvidos || []).some(item =>
            (draft.id && item.id === draft.id) || (draft._id && String(item._id) === String(draft._id))));
    })


    //Envolvido manipulado no formulário
    //dados dos envolvidos na ocorrencia, os dados previsto para o preencimento de envolvidos na ocorrencia
    const [envolvido, setEnvolvido] = useState(() =>
        normalizarEnvolvido(boletim.formDrafts?.envolvido || {})
    )

    return (
         <div className="bo-form-root">
            <CabecalhoBoletim texto={"Adicionar Envolvidos "}/>
            {/* exibe formulario para preencher ou editar os dados dos envolvidos */}
            <FormEnvolvido  envolvido={envolvido} setEnvolvido={setEnvolvido} modoEdicao={modoEdicao} setModoEdicao={setModoEdicao}/>
            {/* exibe a lista dos evolvidos ja adicionado na relação de envolvidos, alem de botoes para editar/excluir */}
            <EnvolvidoList envolvido={envolvido} setEnvolvido={setEnvolvido} modoEdicao={modoEdicao} setModoEdicao={setModoEdicao}/>
            <NavPage prev="../header" next="../material"/>
        </div>
    )
}

export default Envolvidos
